// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j4B0F","input":"styles_input__2-FXq"};